import styled from '@emotion/styled';
import {
  Alert,
  styleUtils,
  theme,
} from '@minted/minted-components';

const FormContainer = styled.div`
  width: min(100%, ${styleUtils.rem(500)});
`;

const FormHeading = styled.h1`
  ${theme.typeStyles.displayExtraSmallStyles}

  font-weight: ${theme.typeStyles.fontWeightDemi};
  margin-bottom: ${theme.spacing.x6};
`;

const FormSubheading = styled.h2`
  ${theme.typeStyles.bodySmallStyles}

  margin-bottom: ${theme.spacing.x4};
  display: flex;
  flex-direction: row;

`;

const BottomSpacer = styled.div`
  margin-bottom: ${theme.spacing.x4};
`;

// If you wrap a minted component in a div without any other content the
// div is assigned a width of 0 and the component inherits that. A width
// of 100% allows the component to fill the remaining space like normal.
const FullWidthWrapper = styled.div`
  width: 100%;
`;

const TermsAndPrivacy = styled.p`
  ${theme.typeStyles.bodyExtraSmallStyles}

  color: ${theme.colors.grayDarker};

  ${theme.media.greaterThan(theme.breakpoints.small)('position: relative;')}
  a:hover {
    color: ${theme.colors.black};
  }
  strong {
    ${theme.typeStyles.bodyBoldStyles}
  }
`;

const FormErrors = styled(Alert)`
  margin-bottom: ${theme.spacing.x4};
`;

const FieldContainer = styled.div`
  margin-bottom: ${theme.spacing.x4};

  &:last-child {
    margin-bottom: 0;
  }
`;

// Style override to retain link color in App-Renderer.
const PrimaryButtonFieldContainer = styled(FieldContainer)`
  a:hover {
    color: ${theme.colors.white};
  }
`;
// Style override to retain link color in App-Renderer.
const SecondaryButtonFieldContainer = styled(FieldContainer)`
  a:hover {
    color: ${theme.colors.black};
  }
`;

const StyledTextLinkInline = styled.span`
  ${theme.typeStyles.bodyMediumStyles}
  ${theme.typeStyles.bodyBoldStyles}

  text-transform: uppercase;
  a:hover {
    color: ${theme.colors.black};
  }
`;

const NavigationLink = styled.span`
  margin-left: ${theme.spacing.base};
  a:hover {
    color: ${theme.colors.black};
  }
`;

export {
  BottomSpacer,
  FieldContainer,
  FormContainer,
  FormErrors,
  FormHeading,
  FormSubheading,
  FullWidthWrapper,
  NavigationLink,
  PrimaryButtonFieldContainer,
  SecondaryButtonFieldContainer,
  StyledTextLinkInline,
  TermsAndPrivacy,
};
